import axios from "axios";

// 백엔드 API 주소 (환경변수 또는 로컬 주소)
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:8080";

export const getAdminNotices = async (params: { searchKeyword?: string, page: number, size: number }) => {
  const response = await axios.get(`${API_BASE_URL}/api/admin/notices`, { params });
  return response.data;
}

export const getAdminNotice = async (noticeId: number) => {
  const response = await axios.get(`${API_BASE_URL}/api/admin/notices/${noticeId}`);
  return response.data;
}

export const createAdminNotice = async (data: any) => {
  const response = await axios.post(`${API_BASE_URL}/api/admin/notices`, data);
  return response.data;
}

export const updateAdminNotice = async (noticeId: number, data: any) => {
  const response = await axios.put(`${API_BASE_URL}/api/admin/notices/${noticeId}`, data);
  return response.data;
}

export const deleteAdminNotice = async (noticeId: number) => {
  const response = await axios.delete(`${API_BASE_URL}/api/admin/notices/${noticeId}`);
  return response.data;
}